module.exports = __webpack_public_path__ + "img/contenedor.a1171e1f.svg";